<template>
  <div class="bp">
    <!-- Navbar (identico Home) -->
    <nav class="hp-nav" :class="{ 'hp-nav--scrolled': navScrolled }">
      <div class="hp-container hp-nav__inner">
        <div class="hp-nav__logo">
          <router-link to="/"><img src="/logo-booster.png" alt="VSLBooster" class="hp-nav__logo-img" /></router-link>
        </div>
        <div class="hp-nav__links hide-mobile">
          <a href="/#funcionalidades" class="hp-nav-link">Funcionalidades</a>
          <a href="/#como-funciona" class="hp-nav-link">Como funciona</a>
          <a href="/#precos" class="hp-nav-link">Precos</a>
          <a href="/#depoimentos" class="hp-nav-link">Depoimentos</a>
          <router-link to="/blog" class="hp-nav-link">Blog</router-link>
        </div>
        <div class="hp-nav__actions">
          <router-link to="/login" class="hp-nav-link" style="margin-right:4px">Entrar</router-link>
          <router-link to="/cadastro-trial" class="hp-nav-contact-btn">Fale Conosco</router-link>
        </div>
      </div>
    </nav>
    <div style="height:72px"></div>

    <div v-if="loading" class="bp-loading">Carregando artigo...</div>
    <div v-else-if="!post" class="bp-empty">
      <feather-icon icon="FileTextIcon" size="48" />
      <h2>Artigo nao encontrado</h2>
      <router-link to="/blog" class="bp-empty__link">Voltar ao Blog</router-link>
    </div>
    <template v-else>
      <!-- Full-width Hero Image -->
      <div class="bp-hero" :style="post.cover_image ? { backgroundImage: 'url(' + post.cover_image + ')' } : {}">
        <div class="bp-hero__overlay"></div>
      </div>

      <!-- Toolbar -->
      <div class="bp-toolbar">
        <router-link to="/blog" class="bp-toolbar__back">
          <feather-icon icon="ArrowLeftIcon" size="16" class="mr-50" />Voltar ao Blog
        </router-link>
        <div class="bp-toolbar__actions">
          <button class="bp-toolbar__btn" @click="shareOpen = !shareOpen">
            <feather-icon icon="Share2Icon" size="15" class="mr-50" />Compartilhar
          </button>
        </div>
      </div>

      <!-- Share dropdown -->
      <div v-if="shareOpen" class="bp-share-dropdown">
        <a :href="'https://twitter.com/intent/tweet?text=' + encodeURIComponent(post.title) + '&url=' + encodeURIComponent(fullUrl)" target="_blank" rel="noopener" class="bp-share-item">
          <span class="bp-share-icon">𝕏</span> Twitter
        </a>
        <a :href="'https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(fullUrl)" target="_blank" rel="noopener" class="bp-share-item">
          <span class="bp-share-icon bp-share-icon--li">in</span> LinkedIn
        </a>
        <a :href="'https://wa.me/?text=' + encodeURIComponent(post.title + ' ' + fullUrl)" target="_blank" rel="noopener" class="bp-share-item">
          <span class="bp-share-icon bp-share-icon--wa">W</span> WhatsApp
        </a>
        <button class="bp-share-item" @click="copyLink">
          <feather-icon icon="LinkIcon" size="14" class="mr-50" /> Copiar link
        </button>
      </div>

      <!-- Article Container -->
      <div class="bp-container">
        <div class="bp-article-grid">
          <!-- Main Content -->
          <article class="bp-main">
            <!-- Meta info -->
            <div class="bp-meta-top">
              <span v-if="post.category_name" class="bp-category" :style="{ background: post.category_color }">{{ post.category_name }}</span>
              <span class="bp-date"><feather-icon icon="CalendarIcon" size="13" class="mr-25" />{{ formatDate(post.published_at) }}</span>
              <span class="bp-reading"><feather-icon icon="ClockIcon" size="13" class="mr-25" />{{ readingTime }} min de leitura</span>
            </div>

            <h1 class="bp-title">{{ post.title }}</h1>

            <div class="bp-author">
              <div class="bp-author__avatar">{{ (post.author_name || 'V')[0] }}</div>
              <div>
                <div class="bp-author__name">{{ post.author_name || 'VSLBooster' }}</div>
                <div class="bp-author__role">Equipe VSLBooster</div>
              </div>
            </div>

            <!-- Breadcrumb (SEO) -->
            <nav class="bp-breadcrumb" aria-label="Breadcrumb">
              <ol itemscope itemtype="https://schema.org/BreadcrumbList">
                <li itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
                  <a itemprop="item" href="/"><span itemprop="name">Home</span></a><meta itemprop="position" content="1" />
                </li>
                <li itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
                  <a itemprop="item" href="/blog"><span itemprop="name">Blog</span></a><meta itemprop="position" content="2" />
                </li>
                <li v-if="post.category_name" itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
                  <a itemprop="item" :href="'/blog?category=' + post.category_slug"><span itemprop="name">{{ post.category_name }}</span></a><meta itemprop="position" content="3" />
                </li>
                <li itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
                  <span itemprop="name">{{ post.title }}</span><meta itemprop="position" :content="post.category_name ? '4' : '3'" />
                </li>
              </ol>
            </nav>

            <!-- Content -->
            <div class="bp-content" v-html="processedContent"></div>

            <!-- Keywords -->
            <div v-if="post.keywords" class="bp-keywords">
              <span v-for="kw in post.keywords.split(',')" :key="kw" class="bp-kw">#{{ kw.trim() }}</span>
            </div>

            <!-- CTA -->
            <div class="bp-cta">
              <div class="bp-cta__left">
                <h3>Pronto para converter mais com video?</h3>
                <p>Teste o VSLBooster gratis por 30 dias. Sem cartao de credito.</p>
              </div>
              <a href="/cadastro-trial" class="bp-cta__btn">Comecar agora &rarr;</a>
            </div>
          </article>

          <!-- Sidebar -->
          <aside class="bp-sidebar">
            <!-- TOC -->
            <div v-if="toc.length > 2" class="bp-toc">
              <h2 class="bp-toc__title">Neste artigo</h2>
              <ul class="bp-toc__list">
                <li v-for="(item, i) in toc" :key="i" :class="'bp-toc__item--' + item.tag">
                  <a :href="'#' + item.id" class="bp-toc__link">{{ item.text }}</a>
                </li>
              </ul>
            </div>

            <!-- Related Posts -->
            <div v-if="relatedPosts.length" class="bp-related">
              <h2 class="bp-related__title">Artigos Relacionados</h2>
              <router-link v-for="rp in relatedPosts" :key="rp.id" :to="'/blog/' + rp.slug" class="bp-related__card">
                <div class="bp-related__img" :style="{ backgroundImage: rp.cover_image ? 'url(' + rp.cover_image + ')' : 'linear-gradient(135deg, #0D1B2E, #E86A10)' }"></div>
                <div class="bp-related__body">
                  <h3>{{ rp.title }}</h3>
                  <span>{{ formatDate(rp.published_at) }}</span>
                </div>
              </router-link>
            </div>

            <!-- Newsletter CTA -->
            <div class="bp-sidebar-cta">
              <feather-icon icon="VideoIcon" size="28" style="color:#E86A10;margin-bottom:10px" />
              <h3>Aumente suas conversoes</h3>
              <p>Descubra como VSLs estao revolucionando as vendas online</p>
              <a href="/cadastro-trial" class="bp-sidebar-cta__btn">Testar Gratis</a>
            </div>
          </aside>
        </div>
      </div>
    </template>

    <!-- Footer -->
    <footer class="bp-footer">
      <div class="bp-footer__inner">
        <div class="bp-footer__grid">
          <div>
            <img src="/logo-booster.png" alt="VSLBooster" style="height:32px;margin-bottom:12px" />
            <p class="bp-footer__desc">A plataforma completa de VSL: player, chat com IA, webinario, heatmap e analytics.</p>
          </div>
          <div>
            <div class="bp-footer__col-title">Plataforma</div>
            <router-link to="/#funcionalidades" class="bp-footer__link">Funcionalidades</router-link>
            <router-link to="/#precos" class="bp-footer__link">Precos</router-link>
            <router-link to="/cadastro-trial" class="bp-footer__link">Teste Gratis</router-link>
          </div>
          <div>
            <div class="bp-footer__col-title">Conteudo</div>
            <router-link to="/blog" class="bp-footer__link">Blog</router-link>
            <router-link to="/documentacao" class="bp-footer__link">Documentacao</router-link>
            <router-link to="/fale-conosco" class="bp-footer__link">Contato</router-link>
          </div>
        </div>
        <div class="bp-footer__bottom">
          <span>&copy; {{ new Date().getFullYear() }} VSLBooster. Todos os direitos reservados.</span>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'BlogPost',
  data() {
    return { post: null, loading: true, relatedPosts: [], toc: [], shareOpen: false, navScrolled: false }
  },
  computed: {
    readingTime() {
      if (!this.post?.content) return 1
      const words = this.post.content.replace(/<[^>]*>/g, '').split(/\s+/).length
      return Math.max(1, Math.round(words / 200))
    },
    fullUrl() {
      return (typeof window !== 'undefined' ? window.location.origin : 'https://app.vslbooster.com') + '/blog/' + (this.post?.slug || '')
    },
    processedContent() {
      if (!this.post?.content) return ''
      let html = this.post.content
      let idx = 0
      html = html.replace(/<(h[23])([^>]*)>(.*?)<\/h[23]>/gi, (match, tag, attrs, text) => {
        const id = 'sec-' + idx++
        return `<${tag}${attrs} id="${id}">${text}</${tag}>`
      })
      return html
    },
  },
  mounted() {
    this.fetchPost()
    this._onScroll = () => { this.navScrolled = window.scrollY > 20 }
    window.addEventListener('scroll', this._onScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this._onScroll)
  },
  methods: {
    async fetchPost() {
      this.loading = true
      try {
        const slug = this.$route.params.slug
        const resp = await fetch(`/api/dkbackend/blog/posts/${slug}`)
        if (resp.ok) {
          this.post = await resp.json()
          this.setAllMeta()
          this.buildToc()
          this.fetchRelated()
          this.injectJsonLd()
        }
      } catch (e) { console.error(e) }
      this.loading = false
    },
    setAllMeta() {
      const p = this.post
      document.title = p.meta_title || p.title + ' | VSLBooster Blog'
      this.setMeta('description', p.meta_description || p.excerpt || '')
      this.setMeta('keywords', p.keywords || '')
      this.setMeta('author', p.author_name || 'VSLBooster')
      this.setMeta('robots', 'index, follow, max-image-preview:large, max-snippet:-1')
      this.setMeta('og:title', p.meta_title || p.title)
      this.setMeta('og:description', p.meta_description || p.excerpt || '')
      this.setMeta('og:type', 'article')
      this.setMeta('og:url', this.fullUrl)
      this.setMeta('og:site_name', 'VSLBooster Blog')
      this.setMeta('og:locale', 'pt_BR')
      if (p.og_image || p.cover_image) {
        this.setMeta('og:image', p.og_image || p.cover_image)
        this.setMeta('og:image:width', '1792')
        this.setMeta('og:image:height', '1024')
      }
      this.setMeta('article:published_time', p.published_at || '')
      this.setMeta('article:modified_time', p.updated_at || '')
      this.setMeta('article:section', p.category_name || 'Marketing Digital')
      this.setMeta('twitter:card', 'summary_large_image')
      this.setMeta('twitter:title', p.meta_title || p.title)
      this.setMeta('twitter:description', p.meta_description || p.excerpt || '')
      if (p.og_image || p.cover_image) this.setMeta('twitter:image', p.og_image || p.cover_image)
      let canonical = document.querySelector('link[rel="canonical"]')
      if (!canonical) { canonical = document.createElement('link'); canonical.setAttribute('rel', 'canonical'); document.head.appendChild(canonical) }
      canonical.setAttribute('href', this.fullUrl)
    },
    injectJsonLd() {
      const p = this.post
      const existing = document.getElementById('blog-jsonld')
      if (existing) existing.remove()
      const schema = {
        '@context': 'https://schema.org', '@type': 'Article',
        headline: p.title,
        description: p.meta_description || p.excerpt || '',
        image: p.cover_image || p.og_image || '',
        author: { '@type': 'Organization', name: p.author_name || 'VSLBooster', url: 'https://app.vslbooster.com' },
        publisher: { '@type': 'Organization', name: 'VSLBooster', url: 'https://app.vslbooster.com', logo: { '@type': 'ImageObject', url: 'https://app.vslbooster.com/logo-booster.png' } },
        datePublished: p.published_at, dateModified: p.updated_at || p.published_at,
        mainEntityOfPage: { '@type': 'WebPage', '@id': this.fullUrl },
        keywords: p.keywords || '', articleSection: p.category_name || 'Marketing Digital',
        wordCount: p.content ? p.content.replace(/<[^>]*>/g, '').split(/\s+/).length : 0, inLanguage: 'pt-BR',
      }
      const faqItems = []
      const faqRegex = /<h3[^>]*>(.*?)<\/h3>\s*<p>([\s\S]*?)<\/p>/gi
      const contentAfterFaq = p.content?.split(/Perguntas Frequentes/i)?.[1] || ''
      let m; while ((m = faqRegex.exec(contentAfterFaq)) !== null) {
        faqItems.push({ '@type': 'Question', name: m[1].replace(/<[^>]*>/g, ''), acceptedAnswer: { '@type': 'Answer', text: m[2].replace(/<[^>]*>/g, '') } })
      }
      const schemas = [schema]
      if (faqItems.length) schemas.push({ '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: faqItems })
      const script = document.createElement('script'); script.id = 'blog-jsonld'; script.type = 'application/ld+json'
      script.textContent = JSON.stringify(schemas.length === 1 ? schemas[0] : schemas)
      document.head.appendChild(script)
    },
    buildToc() {
      if (!this.post?.content) return
      const toc = []; let idx = 0
      const regex = /<(h[23])[^>]*>(.*?)<\/h[23]>/gi; let match
      while ((match = regex.exec(this.post.content)) !== null) {
        toc.push({ tag: match[1].toLowerCase(), text: match[2].replace(/<[^>]*>/g, ''), id: 'sec-' + idx++ })
      }
      this.toc = toc
    },
    async fetchRelated() {
      try {
        const catParam = this.post.category_slug ? `&category=${this.post.category_slug}` : ''
        const resp = await fetch(`/api/dkbackend/blog/posts?limit=4${catParam}`)
        if (resp.ok) {
          const data = await resp.json()
          this.relatedPosts = (data.posts || []).filter(p => p.slug !== this.post.slug).slice(0, 3)
        }
      } catch {}
    },
    setMeta(name, content) {
      const prop = name.startsWith('og:') || name.startsWith('article:') || name.startsWith('twitter:') ? 'property' : 'name'
      let el = document.querySelector(`meta[${prop}="${name}"]`)
      if (!el) { el = document.createElement('meta'); el.setAttribute(prop, name); document.head.appendChild(el) }
      el.setAttribute('content', content)
    },
    formatDate(d) {
      if (!d) return ''
      return new Date(d).toLocaleDateString('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' })
    },
    copyLink() {
      navigator.clipboard.writeText(this.fullUrl)
      this.shareOpen = false
      this.$message && this.$message({ type: 'success', message: 'Link copiado!' })
    },
  },
}
</script>

<style lang="scss" scoped>
$orange: #E86A10;
$navy: #0D1B2E;

/* ── Navbar (identico Home) ──────────────────────────────────── */
.hp-container { max-width: 1120px; margin: 0 auto; padding: 0 24px; }
.hp-nav { position: fixed; top: 0; left: 0; right: 0; z-index: 1000; background: rgba(10,18,35,0.96); backdrop-filter: blur(12px); -webkit-backdrop-filter: blur(12px); border-bottom: 1px solid rgba(255,255,255,0.12); transition: all 0.35s ease; padding: 0 24px; }
.hp-nav--scrolled { background: rgba(10,18,35,1); box-shadow: 0 4px 24px rgba(0,0,0,0.35); border-bottom-color: rgba(255,255,255,0.15); }
.hp-nav__inner { display: flex; align-items: center; justify-content: space-between; height: 72px; }
.hp-nav__logo-img { height: 38px; width: auto; object-fit: contain; }
.hp-nav__links { display: flex; align-items: center; gap: 36px; }
.hp-nav__actions { display: flex; gap: 12px; align-items: center; }
.hp-nav-link { color: #ffffff !important; font-size: 15px; font-weight: 500; transition: all 0.2s ease; padding: 6px 0; text-decoration: none; border-bottom: 2px solid transparent; }
.hp-nav-link:hover { color: #F97316 !important; border-bottom-color: #F97316; }
.hp-nav-contact-btn { color: #ffffff; font-size: 14px; font-weight: 600; padding: 10px 22px; border-radius: 8px; border: 1.5px solid rgba(255,255,255,0.5); transition: all 0.2s ease; cursor: pointer; background: transparent; font-family: inherit; text-decoration: none; display: inline-block; }
.hp-nav-contact-btn:hover { background: rgba(255,255,255,0.15); color: #fff; border-color: rgba(255,255,255,0.8); }
.hide-mobile {}
@media (max-width: 640px) { .hide-mobile { display: none !important; } }

/* ── Footer ─────────────────────────────────────────────────── */
.bp-footer { background: #060d1a; padding: 56px 32px 36px; margin-top: 0; }
.bp-footer__inner { max-width: 1200px; margin: 0 auto; }
.bp-footer__grid { display: grid; grid-template-columns: 2fr 1fr 1fr; gap: 48px; margin-bottom: 36px; padding-bottom: 36px; border-bottom: 1px solid rgba(255,255,255,0.06); }
@media (max-width: 640px) { .bp-footer__grid { grid-template-columns: 1fr; gap: 28px; } }
.bp-footer__desc { color: rgba(255,255,255,0.6); font-size: 0.85rem; line-height: 1.7; max-width: 300px; }
.bp-footer__col-title { color: rgba(255,255,255,0.8); font-size: 11px; font-weight: 700; letter-spacing: 1.5px; text-transform: uppercase; margin-bottom: 14px; }
.bp-footer__link { display: block; color: rgba(255,255,255,0.55); font-size: 0.88rem; text-decoration: none; margin-bottom: 8px; &:hover { color: rgba(255,255,255,0.9); } }
.bp-footer__bottom { color: rgba(255,255,255,0.4); font-size: 0.8rem; }

.bp { background: #fff; min-height: 100vh; }
.bp-loading, .bp-empty { text-align: center; padding: 120px 20px; color: #94a3b8; }
.bp-empty h2 { font-size: 1.3rem; color: #475569; margin: 16px 0 12px; }
.bp-empty__link { color: $orange; font-weight: 600; text-decoration: none; }

/* ── Hero full-width ────────────────────────────────────────── */
.bp-hero {
  width: 100%; height: 480px;
  background: linear-gradient(135deg, $navy 0%, #0a2240 100%);
  background-size: cover; background-position: center;
  position: relative;
}
.bp-hero__overlay {
  position: absolute; inset: 0;
  background: linear-gradient(to bottom, rgba(0,0,0,0.05) 0%, rgba(0,0,0,0.25) 100%);
}
@media (max-width: 768px) { .bp-hero { height: 280px; } }

/* ── Toolbar ────────────────────────────────────────────────── */
.bp-toolbar {
  max-width: 1200px; margin: 0 auto; padding: 20px 32px;
  display: flex; align-items: center; justify-content: space-between;
}
.bp-toolbar__back {
  display: flex; align-items: center; color: #475569; font-size: 14px;
  font-weight: 600; text-decoration: none;
  &:hover { color: $orange; }
}
.bp-toolbar__actions { display: flex; gap: 8px; }
.bp-toolbar__btn {
  display: flex; align-items: center; padding: 8px 18px; border-radius: 8px;
  border: 1.5px solid #e2e8f0; background: #fff; font-size: 13px; font-weight: 600;
  color: #475569; cursor: pointer; font-family: inherit;
  &:hover { border-color: $orange; color: $orange; }
}

/* ── Share ───────────────────────────────────────────────────── */
.bp-share-dropdown {
  max-width: 1200px; margin: 0 auto; padding: 0 32px;
  display: flex; gap: 8px; flex-wrap: wrap; margin-bottom: 8px;
}
.bp-share-item {
  display: flex; align-items: center; gap: 6px; padding: 8px 16px;
  border-radius: 8px; border: 1px solid #e2e8f0; background: #fff;
  font-size: 13px; font-weight: 600; color: #475569; cursor: pointer;
  text-decoration: none; font-family: inherit;
  &:hover { border-color: $orange; color: $orange; }
}
.bp-share-icon { font-weight: 800; font-size: 14px; }
.bp-share-icon--li { color: #0A66C2; }
.bp-share-icon--wa { color: #25D366; }

/* ── Container ──────────────────────────────────────────────── */
.bp-container { max-width: 1200px; margin: 0 auto; padding: 0 32px 60px; }

.bp-article-grid {
  display: grid; grid-template-columns: 1fr 320px; gap: 48px;
}
@media (max-width: 960px) { .bp-article-grid { grid-template-columns: 1fr; } }

/* ── Main ───────────────────────────────────────────────────── */
.bp-main { min-width: 0; }

.bp-meta-top {
  display: flex; align-items: center; gap: 16px; flex-wrap: wrap;
  margin-bottom: 16px; font-size: 13px; color: #64748b;
}
.bp-category {
  padding: 4px 14px; border-radius: 6px; font-size: 12px;
  font-weight: 700; color: #fff;
}
.bp-date, .bp-reading { display: flex; align-items: center; }

.bp-title {
  font-size: 2.6rem; font-weight: 900; color: #0f172a;
  line-height: 1.15; margin: 0 0 24px; letter-spacing: -0.5px;
}
@media (max-width: 768px) { .bp-title { font-size: 1.8rem; } }

.bp-author {
  display: flex; align-items: center; gap: 12px;
  margin-bottom: 24px; padding-bottom: 24px; border-bottom: 1px solid #f1f5f9;
}
.bp-author__avatar {
  width: 44px; height: 44px; border-radius: 50%;
  background: linear-gradient(135deg, $orange, #F59E0B);
  display: flex; align-items: center; justify-content: center;
  color: #fff; font-weight: 800; font-size: 18px;
}
.bp-author__name { font-size: 14px; font-weight: 700; color: #0f172a; }
.bp-author__role { font-size: 12px; color: #94a3b8; }

/* Breadcrumb (compact, below author) */
.bp-breadcrumb { margin-bottom: 28px; }
.bp-breadcrumb ol { display: flex; flex-wrap: wrap; gap: 4px; list-style: none; padding: 0; margin: 0; font-size: 12px; color: #94a3b8; }
.bp-breadcrumb li { display: flex; align-items: center; }
.bp-breadcrumb li + li::before { content: '/'; margin: 0 6px; color: #cbd5e1; }
.bp-breadcrumb a { color: #94a3b8; text-decoration: none; &:hover { color: $orange; } }

/* ── Content ────────────────────────────────────────────────── */
.bp-content {
  font-size: 1.1rem; line-height: 1.9; color: #334155;

  ::v-deep h2 {
    font-size: 1.6rem; font-weight: 800; color: #0f172a;
    margin: 44px 0 16px; padding-top: 12px;
    border-top: 1px solid #f1f5f9; scroll-margin-top: 80px;
  }
  ::v-deep h2:first-child { border-top: none; margin-top: 0; padding-top: 0; }
  ::v-deep h3 { font-size: 1.25rem; font-weight: 700; color: #1e293b; margin: 32px 0 12px; scroll-margin-top: 80px; }
  ::v-deep p { margin: 0 0 20px; }
  ::v-deep ul, ::v-deep ol { margin: 0 0 20px; padding-left: 24px; }
  ::v-deep li { margin-bottom: 10px; line-height: 1.75; }
  ::v-deep blockquote {
    border-left: 4px solid $orange; margin: 28px 0; padding: 20px 28px;
    background: #FFF7ED; color: #92400e; font-style: italic;
    border-radius: 0 12px 12px 0; font-size: 1.08rem; line-height: 1.7;
  }
  ::v-deep img { max-width: 100%; height: auto; border-radius: 12px; margin: 8px 0; display: block; }
  ::v-deep figure { margin: 28px 0; }
  ::v-deep figcaption { font-size: 0.82rem; color: #94a3b8; text-align: center; margin-top: 10px; font-style: italic; }
  ::v-deep a {
    color: $orange; text-decoration: underline; text-underline-offset: 3px;
    font-weight: 500; &:hover { color: darken($orange, 12%); }
  }
  ::v-deep strong { color: #0f172a; }
  ::v-deep table { width: 100%; border-collapse: collapse; margin: 20px 0; border-radius: 8px; overflow: hidden; }
  ::v-deep th, ::v-deep td { padding: 12px 16px; border: 1px solid #e2e8f0; text-align: left; font-size: 0.95rem; }
  ::v-deep th { background: #f8fafc; font-weight: 700; color: #334155; }
}

/* Keywords */
.bp-keywords { display: flex; flex-wrap: wrap; gap: 8px; margin: 36px 0 24px; }
.bp-kw {
  padding: 6px 14px; border-radius: 20px; background: #f1f5f9;
  color: #475569; font-size: 13px; font-weight: 600;
}

/* CTA (inline) */
.bp-cta {
  display: flex; align-items: center; justify-content: space-between; gap: 20px;
  padding: 32px; background: linear-gradient(135deg, $navy, #0a2240);
  border-radius: 16px; margin: 36px 0; color: #fff;
}
.bp-cta h3 { font-size: 1.2rem; font-weight: 800; margin: 0 0 6px; }
.bp-cta p { color: rgba(255,255,255,0.7); margin: 0; font-size: 0.9rem; }
.bp-cta__btn {
  padding: 14px 28px; border-radius: 10px; background: $orange; color: #fff;
  font-weight: 700; text-decoration: none; white-space: nowrap; font-size: 14px;
  box-shadow: 0 6px 20px rgba(232,106,16,0.35); transition: all 0.2s;
  &:hover { transform: translateY(-2px); box-shadow: 0 10px 28px rgba(232,106,16,0.5); }
}
@media (max-width: 600px) { .bp-cta { flex-direction: column; text-align: center; } }

/* ── Sidebar ────────────────────────────────────────────────── */
.bp-sidebar { position: sticky; top: 24px; align-self: start; }
@media (max-width: 960px) { .bp-sidebar { position: static; } }

.bp-toc {
  background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 12px;
  padding: 20px; margin-bottom: 20px;
}
.bp-toc__title { font-size: 12px; font-weight: 800; color: #64748b; margin: 0 0 14px; text-transform: uppercase; letter-spacing: 1px; }
.bp-toc__list { list-style: none; padding: 0; margin: 0; }
.bp-toc__list li { margin-bottom: 4px; }
.bp-toc__item--h3 { padding-left: 14px; }
.bp-toc__link {
  color: #475569; text-decoration: none; font-size: 13px; font-weight: 500;
  display: block; padding: 4px 8px; border-radius: 6px;
  &:hover { color: $orange; background: rgba($orange, 0.06); }
}

.bp-related { margin-bottom: 20px; }
.bp-related__title { font-size: 12px; font-weight: 800; color: #64748b; margin: 0 0 14px; text-transform: uppercase; letter-spacing: 1px; }
.bp-related__card {
  display: flex; gap: 12px; text-decoration: none; padding: 10px 0;
  border-bottom: 1px solid #f1f5f9;
  &:last-child { border-bottom: none; }
  &:hover h3 { color: $orange; }
}
.bp-related__img { width: 72px; height: 52px; border-radius: 8px; background-size: cover; background-position: center; flex-shrink: 0; }
.bp-related__body h3 { font-size: 13px; font-weight: 700; color: #1e293b; margin: 0 0 4px; line-height: 1.35; transition: color 0.15s; }
.bp-related__body span { font-size: 11px; color: #94a3b8; }

.bp-sidebar-cta {
  background: linear-gradient(135deg, #FFF7ED, #FEF3C7); border: 1px solid #FDE68A;
  border-radius: 12px; padding: 24px; text-align: center;
}
.bp-sidebar-cta h3 { font-size: 15px; font-weight: 800; color: #0f172a; margin: 0 0 6px; }
.bp-sidebar-cta p { font-size: 13px; color: #64748b; margin: 0 0 14px; }
.bp-sidebar-cta__btn {
  display: inline-block; padding: 10px 24px; border-radius: 8px; background: $orange;
  color: #fff; font-weight: 700; font-size: 13px; text-decoration: none;
  &:hover { opacity: 0.9; }
}

// ── Mobile Responsiveness ───────────────────────────────
@media (max-width: 768px) {
  .bp-container { padding: 0 16px 40px; }
  .bp-toolbar { padding: 16px; }
  .bp-hero { height: 260px; }
  .bp-title { font-size: 1.6rem; }
  .bp-author { margin-bottom: 16px; padding-bottom: 16px; }
  .bp-content {
    font-size: 1rem;
    ::v-deep h2 { font-size: 1.3rem; margin: 28px 0 12px; }
    ::v-deep h3 { font-size: 1.1rem; margin: 20px 0 8px; }
    ::v-deep table { display: block; overflow-x: auto; -webkit-overflow-scrolling: touch; }
    ::v-deep blockquote { padding: 14px 18px; margin: 16px 0; }
  }
  .bp-share-dropdown { padding: 0 16px; }
  .bp-related__grid { grid-template-columns: 1fr; }
}
@media (max-width: 480px) {
  .bp-container { padding: 0 12px 32px; }
  .bp-toolbar { padding: 12px; }
  .bp-hero { height: 200px; }
  .bp-title { font-size: 1.4rem; letter-spacing: -0.3px; }
  .bp-meta-top { gap: 8px; font-size: 11px; }
  .bp-nav__inner { padding: 0 16px; }
  .bp-cta { padding: 24px 16px; }
  .bp-cta h3 { font-size: 1rem; }
  .bp-footer__inner { flex-direction: column; text-align: center; }
}
</style>
